import { Palette } from '@core/config/constants';

/** Un accesorio comprable en la tienda. Se representa con un emoji sobre el personaje. */
export interface ShopItem {
  /** Identificador unico (se guarda en el perfil). */
  readonly id: string;
  /** Nombre visible. */
  readonly name: string;
  /** Emoji que se muestra como accesorio sobre la cabeza del personaje. */
  readonly emoji: string;
  /** Precio en estrellas (monedas del juego). */
  readonly price: number;
  /** Color de la tarjeta en la tienda. */
  readonly color: number;
}

/**
 * Catalogo de accesorios de la tienda. Las estrellas que se ganan en los minijuegos
 * se gastan aca. Mantener precios bajos para que se sienta alcanzable para chicos.
 */
export const SHOP_ITEMS: readonly ShopItem[] = [
  { id: 'crown', name: 'Corona', emoji: '👑', price: 10, color: Palette.highlight },
  { id: 'bow', name: 'Moño', emoji: '🎀', price: 8, color: Palette.primary },
  { id: 'glasses', name: 'Lentes', emoji: '🕶️', price: 8, color: Palette.secondary },
  { id: 'flower', name: 'Flor', emoji: '🌸', price: 6, color: Palette.primary },
  { id: 'headphones', name: 'Auriculares', emoji: '🎧', price: 12, color: Palette.accent },
  { id: 'star', name: 'Estrella', emoji: '🌟', price: 15, color: Palette.highlight },
];

/** Devuelve un accesorio por su id (o undefined si no existe). */
export function findShopItem(id: string): ShopItem | undefined {
  return SHOP_ITEMS.find((item) => item.id === id);
}
